import { useContext } from "react";
import { useNavigate } from "react-router-dom";

import nav from "../../../assets/images/icons/nav-icon.svg";
import avatar from "../../../assets/images/profile_placeholder.png";
import dataContext from "../../../context/dataContext";
import mainContext from "../../../context/mainContext";

import styles from "./style.module.css";
import { Dashboard } from "../../../pages/commonPages";
import { TbHomeMove } from "react-icons/tb";

// const pagesHeadersWithOutBTNs = ["Dashboard".toLowerCase(), "settings".toLowerCase(), "Comprehension".toLowerCase()]
const pagesHeadersWithOutBTNs = ["Dashboard".toLowerCase(), "settings".toLowerCase(),]
export default function Header({ pageName }) {
  const {
    nav: { setIsShowNav }, avatarData
  } = useContext(mainContext);
  const { userDetails, serverData } = useContext(dataContext);
  let navigate = useNavigate();

  function capitalizeFirstLetter(str) {
    return str.charAt(0).toUpperCase() + str.slice(1);
  }

  const handleHome = () => navigate("/");


  const handleOpenNav = () => setIsShowNav((old) => !old);
  const hideProfillPicNavBtn = !pagesHeadersWithOutBTNs.includes(pageName.toLowerCase());
  let iphoneMode = window.buildType !== "android";
  return (
    <div className={styles["header"]} style={iphoneMode ? { justifyContent: "space-between" } : { justifyContent: hideProfillPicNavBtn ? "space-around" : "space-between" }}>
      {!hideProfillPicNavBtn && <div className={styles["left"]} onClick={handleOpenNav}>
        <img
          src={nav}
          alt={styles["navbar"]}

        ></img>
      </div>}


      {(hideProfillPicNavBtn && iphoneMode) && <div style={{ transform: "scaleX(-1)" }} className={styles["left"]} onClick={handleHome}>

        <TbHomeMove size={"35px"} color="#7d56a5" />

      </div>}
      <div className={pageName.length >= 20 ? styles["mid-mini"] : pageName.length >= 28 ? styles["mid-super-mini"] : styles["mid"]}>{pageName.toUpperCase() == "DASHBOARD" ? <div className={styles["dashboardTitle"]}><div>DASHBOARD</div> <div>Hi {capitalizeFirstLetter(userDetails.firstName.toLowerCase())}</div></div> : pageName.toUpperCase()}</div>
      {(hideProfillPicNavBtn && iphoneMode) && <div style={{ minWidth: "9%" }}></div>}
      {!hideProfillPicNavBtn && <div onClick={() => {
        console.log('clicked');
        navigate("/settings");
      }}
        style={{ backgroundImage: `url(${userDetails.image ? userDetails.image.includes('https://') ? userDetails.image : avatar : avatar})` }} className={styles["right"]}>
        {/* <img
          src={userDetails.image ? userDetails.image.includes('https://') ? userDetails.image : `${serverData.url}/${userDetails.image}` : avatar}
          alt={userDetails.firstName}
          onClick={() => {
            console.log('clicked');
            navigate("/settings", { replace: true });
          }}
          className={styles.avatarImage}
        /> */}
      </div>}
    </div>
  );
}
